import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
} from '@angular/core';
import { iconsMapForCmmsTableName } from '@shared/ui-components/au-body-heading-component/au-body-heading-icons.config';
import { TranslateService } from '@tolgee/ngx';
import { NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

interface IIconToFieldMap {
	tooltip: string;
	icon: string;
}

@Component({
	selector: 'au-body-text-heading',
	templateUrl: 'au-body-heading.component.html',
	styleUrls: ['au-body-heading.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [NgClass, MatIcon, MatTooltip],
})
export class AuBodyHeadingComponent implements OnInit {
	@Input() text: string;
	@Input() fallbackText = '';
	@Input() class: string;
	@Input() isClickable = false;
	@Input() iconKey: string;
	@Input() item: { [key: string]: any };
	@Input() nonBold = false;

	@Output() selectElement = new EventEmitter<any>();

	iconConfig: IIconToFieldMap;

	constructor(
		private cdr: ChangeDetectorRef,
		private translationService: TranslateService
	) {}

	ngOnInit() {
		this.iconConfig = this.getIconConfig();
		this.cdr.detectChanges();
	}

	getIconConfig(): IIconToFieldMap {
		if (!this.item[this.iconKey]) {
			return null;
		}

		const config = iconsMapForCmmsTableName[this.iconKey];
		return {
			icon: config.icon,
			tooltip: this.translationService.instant(config.tooltip),
		};
	}
}
